// @ts-check
import { BETSLIP_TYPES, BETSLIP_TYPE_NAMES } from 'bto-models/betslip';
import { state } from '../state';
import { calculateBonuses } from './calculations';
import { saveState } from './helpers';
import { toggleAlgoActive } from './algo';

/**
 * @typedef {import('bto-models/betslip/interfaces').BetslipTabs} BetslipTabs
 */

let _tabs = null;

/**
 * Get betslip ordered tabs from settings
 * @returns {BetslipTabs[]}
 */
export const getTabs = () => {
	if (_tabs) return _tabs;
	if (APP_SETTINGS && APP_SETTINGS.betslip_v2 && APP_SETTINGS.betslip_v2.tabs) {
		_tabs = APP_SETTINGS.betslip_v2.tabs.split(',').reduce((tabs, tabName) => {
			const keyName = tabName.trim().toUpperCase();
			if (BETSLIP_TYPES[keyName]) {
				tabs.push({ name: keyName, id: BETSLIP_TYPES[keyName], translation: BETSLIP_TYPE_NAMES[keyName] });
			}
			return tabs;
		}, []);
		return _tabs;
	}
	console.error("Settings for tabs were not set in betslip settings");
	return [];
};

/**
 * Change selected betslip tab
 * @param {import('bto-models/betslip/interfaces').TBetslipTypes} tab - new tab
 */
export const changeTab = (tab) => {
	state.selectedTab = tab;
	if (APP_SETTINGS.betslip_v2.algoTabMode) {
		const isActive = tab === BETSLIP_TYPES.COMBI;
		Object.values(state.algoItems).forEach(item => {
			if (item.isActive !== isActive) {
				toggleAlgoActive(item.algoItem);
			}
		});
	}
	calculateBonuses();
	saveState();
};